// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-mobile-header {
  display: none;
}

.dashboard-sidebar {
  z-index: 10;
  max-width: 375px;
}
.dashboard-sidebar.hidden {
  display: none;
}

@media (max-width: 768px) {
  /* Hide the main navbar on event dashboard mobile */
  :global(.navbar) {
    display: none;
  }
  .dashboard-mobile-header {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: white;
    border-bottom: 1px solid #e0e0e0;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    z-index: 39;
  }
  .dashboard-mobile-header .back-button,
  .dashboard-mobile-header .menu-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #101010;
    font-size: 0;
    transition: transform 0.18s ease, background 0.18s ease;
  }
  .dashboard-mobile-header .back-button.open,
  .dashboard-mobile-header .menu-button.open {
    transform: rotate(90deg);
  }
  .dashboard-mobile-header .back-button:hover,
  .dashboard-mobile-header .menu-button:hover {
    background: #f5f5f5;
    border-radius: 4px;
  }
  .dashboard-sidebar {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100% !important;
    height: calc(100vh - 60px);
    max-width: none;
    background: white;
    overflow-y: auto;
    transition: transform 0.3s ease-in-out;
  }
  .dashboard-sidebar.hidden {
    transform: translateX(-100%);
  }
}
/* Replaced mobile drawer with dropdown anchored under menu button */
.menu-wrapper {
  border-radius: 12px;
  border: 1px solid #F3F3F3;
  background: #FDFDFD;
  overflow: auto;
  max-height: 60vh;
  min-width: 220px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.08);
}
.menu-wrapper .menu-item {
  color: #101010;
}
.menu-wrapper .divider {
  height: 1px;
  background: #F3F3F3;
}

.dashboard-share-modal .modal-container {
  width: 560px !important;
  height: 350px !important;
}`, "",{"version":3,"sources":["webpack://./src/routes/event-dashboard/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,mDAAA;EACA;IACE,aAAA;EAAF;EAGA;IACE,aAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,YAAA;IACA,iBAAA;IACA,gCAAA;IACA,mBAAA;IACA,8BAAA;IACA,eAAA;IACA,WAAA;EADF;EAGE;;IAEE,gBAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,cAAA;IACA,YAAA;IAEA,uDAAA;EAFJ;EAII;;IACE,wBAAA;EADN;EAII;;IACE,mBAAA;IACA,kBAAA;EADN;EAMA;IACE,eAAA;IACA,SAAA;IACA,OAAA;IACA,sBAAA;IACA,0BAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,sCAAA;EAJF;EAMI;IACE,4BAAA;EAJN;AACF;AAQE,oEAAA;AACE;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CAAA;AANJ;AAQI;EAA0C,cAAA;AAL9C;AAMI;EAAW,WAAA;EAAa,mBAAA;AAF5B;;AAKE;EACE,uBAAA;EACA,wBAAA;AAFJ","sourcesContent":[".dashboard-mobile-header {\n  display: none;\n}\n\n.dashboard-sidebar {\n  z-index: 10;\n  max-width: 375px;\n  \n  &.hidden {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  /* Hide the main navbar on event dashboard mobile */\n  :global(.navbar) {\n    display: none;\n  }\n\n  .dashboard-mobile-header {\n    display: flex;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 60px;\n    background: white;\n    border-bottom: 1px solid #e0e0e0;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 1rem;\n    z-index: 39;\n\n    .back-button,\n    .menu-button {\n      background: none;\n      border: none;\n      cursor: pointer;\n      padding: 0.5rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #101010;\n      font-size: 0;\n\n      transition: transform 0.18s ease, background 0.18s ease;\n\n      &.open {\n        transform: rotate(90deg);\n      }\n\n      &:hover {\n        background: #f5f5f5;\n        border-radius: 4px;\n      }\n    }\n  }\n\n  .dashboard-sidebar {\n    position: fixed;\n    top: 60px;\n    left: 0;\n    width: 100% !important;\n    height: calc(100vh - 60px);\n    max-width: none;\n    background: white;\n    overflow-y: auto;\n    transition: transform 0.3s ease-in-out;\n    \n      &.hidden {\n        transform: translateX(-100%);\n    }\n  }\n}\n\n  /* Replaced mobile drawer with dropdown anchored under menu button */\n    .menu-wrapper {\n    border-radius: 12px;\n    border: 1px solid theme('colors.grey-10');\n    background: theme('colors.white');\n    overflow: auto;\n    max-height: 60vh;\n    min-width: 220px;\n    box-shadow: 0 6px 20px rgba(16,24,40,0.08);\n\n    .menu-item { @extend .label-16 !optional; color: theme('colors.black'); }\n    .divider { height: 1px; background: theme('colors.grey-10'); }\n  }\n.dashboard-share-modal {\n  .modal-container {\n    width: 560px !important;\n    height: 350px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
